import { Check } from "lucide-react";

interface PhaseIndicatorProps {
  currentPhase: 1 | 2;
}

export const PhaseIndicator = ({ currentPhase }: PhaseIndicatorProps) => {
  return (
    <div className="flex items-center justify-center gap-2 py-4">
      <div className="flex items-center gap-2">
        <div
          className={`flex h-8 w-8 items-center justify-center rounded-full ${
            currentPhase >= 1
              ? "bg-primary text-primary-foreground"
              : "bg-muted text-muted-foreground"
          }`}
        >
          {currentPhase > 1 ? <Check className="h-4 w-4" /> : "1"}
        </div>
        <span
          className={`text-sm font-medium ${
            currentPhase === 1 ? "text-foreground" : "text-muted-foreground"
          }`}
        >
          Basic Info
        </span>
      </div>

      <div className="h-px w-12 bg-border" />

      <div className="flex items-center gap-2">
        <div
          className={`flex h-8 w-8 items-center justify-center rounded-full ${
            currentPhase >= 2
              ? "bg-primary text-primary-foreground"
              : "bg-muted text-muted-foreground"
          }`}
        >
          2
        </div>
        <span
          className={`text-sm font-medium ${
            currentPhase === 2 ? "text-foreground" : "text-muted-foreground"
          }`}
        >
          AI Interview
        </span>
      </div>
    </div>
  );
};
